import React, { useState } from 'react';

import { MdFormatListBulleted } from 'react-icons/md';

import type { Position } from '@modules/advancement/duck/types';
import type {
  DefaultSubUnit,
  RosterTableData,
  RosterTableSubUnit,
} from '@modules/advancement/packRoster/types';
import { Dropdown } from '@shared/components';

import { SubUnitMenu } from './SubUnitMenu/SubUnitMenu';

type Props = {
  data: RosterTableData;
  defaultSubUnitList: DefaultSubUnit[];
  approvedSubUnits: RosterTableSubUnit[];
  hasSubUnitOnlyPerms: boolean;
  canEditAllSubUnits: boolean;
  mySubUnits: Position[];
  showSubUnits: boolean;
};

export const EditSubUnits: React.FC<Props> = ({
  data,
  defaultSubUnitList,
  approvedSubUnits,
  hasSubUnitOnlyPerms,
  canEditAllSubUnits,
  mySubUnits,
  showSubUnits,
}) => {
  const [visible, setVisible] = useState<boolean>(false);

  const onVisibleChange = (isVisible: boolean) => setVisible(isVisible);

  const onItemPress = () => setVisible(false);

  const handleClickSubUnitMenu = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.stopPropagation();
  };

  const getFormattedData = (data: RosterTableData): RosterTableData => {
    const defaultValues = defaultSubUnitList.find(
      item => item.userId === data.userId,
    );
    let subUnitFound;
    if (defaultValues) {
      subUnitFound = approvedSubUnits.find(
        subUnit => subUnit.subUnitId === defaultValues.subUnitId,
      );
    }

    return {
      ...data,
      ...defaultValues,
      subUnitName: subUnitFound ? subUnitFound.subUnitName : data.subUnitName,
    };
  };

  const getCanDoActions = (
    showSubUnits: boolean,
    data: RosterTableData,
    formattedData: RosterTableData,
  ) => {
    if (hasSubUnitOnlyPerms && !canEditAllSubUnits) {
      const dataToUse = showSubUnits ? data : formattedData;

      if (dataToUse.subUnitId === -1) return true;

      const hasMatchingSubUnits = mySubUnits.some(sub => {
        const mySubId = sub.denId || sub.patrolId;
        return mySubId === dataToUse.subUnitId;
      });
      return hasMatchingSubUnits;
    }

    return canEditAllSubUnits;
  };

  const formattedData = getFormattedData(data);

  if (!getCanDoActions(showSubUnits, data, formattedData)) return null;

  return (
    <Dropdown
      overlay={
        <SubUnitMenu
          data={showSubUnits ? data : formattedData}
          onPress={onItemPress}
        />
      }
      onVisibleChange={onVisibleChange}
      visible={visible}
      placement="bottomRight"
      trigger={['click', 'hover']}
      // @ts-expect-error: not native Dropdown onClick
      onClick={handleClickSubUnitMenu}
    >
      <MdFormatListBulleted />
    </Dropdown>
  );
};
